import React, { useEffect, useState, useMemo } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const ParticlesBackground = ({ active }) => {
  const [init, setInit] = useState(false);

  // Initialisation du moteur de particules (une seule fois)
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  // Configuration "Architecte / Minimaliste"
  const options = useMemo(
    () => ({
      // Le fond est transparent pour laisser voir votre dégradé CSS existant
      background: {
        color: {
          value: "transparent",
        },
      },
      fpsLimit: 120,
      interactivity: {
        events: {
          onClick: {
            enable: true,
            mode: "bubble", // Ajoute des points au clic repulse, push, bubble
          },
          onHover: {
            enable: true,
            mode: "repulse", // Connecte les points à la souris (style réseau)
          },
        },
        modes: {

          repulse: {
            distance: 140,
            links: {
              opacity: 0.5
            }
          },
        },
      },
      particles: {
        color: {
          value: "#000000", // NOIR/GRIS pour être visible sur fond blanc
        },
        links: {
          color: "#000000",
          distance: 200,
          enable: true,
          opacity: 0.2, // Lignes très discrètes
          width: 1,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "bounce",
          },
          random: false,
          speed: 1, // Mouvement lent et calme
          straight: false,
        },
        number: {
          density: {
            enable: true,
            area: 2000,
          },
          value: 80, // Nombre de points augmenté
        },
        opacity: {
          value: 0.3, // Points semi-transparents
        },
        shape: {
          type: "edge", // Ou "edge" pour des carrés plus architecturaux
        },
        size: {
          value: { min: 1, max: 3 },
        },
      },
      detectRetina: true,
    }),
    [],
  );

  if (init && active) {
    return (
      <Particles
        id="tsparticles"
        options={options}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 999, // Au-dessus de l'interface (panneaux opaques) pour être visible pendant la génération
          pointerEvents: "none", // Ne bloque pas les clics (ex: bouton STOPPER) sous l'animation
        }}
      />
    );
  }

  return <></>;
};

export default ParticlesBackground;
